import styled from 'styled-components';
import mailImage from 'views/AuthView/assets/images/buzon.png';

const StyledEmailSentView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 30px;
  width: 100%;
  box-sizing: border-box;

  #resend-again {
    margin-top: 0;
    color: #75b753;
  }
`;

const Text = styled.span<any>`
  font-size: 1.6rem;
  color: #333;
  letter-spacing: 0;
  line-height: 21px;
  text-align: center;
  font-weight: ${({ strong }) => (strong ? '600' : '300')};
`;

const ImageWrapper = styled.div`
  width: 205px;
  display: flex;
  text-align: center;
  margin: 20px 0 0 0;
`;

const UserEmail = styled.p`
  font-weight: bold;
`;

const Title = styled.span`
  display: block;
  font-size: 24px;
  font-weight: bold;
  ${({ theme }) => `
    color: ${theme.colors.blue};
  `};
  letter-spacing: 0;
  line-height: 47px;
  margin: 10px 0 0;
`;

const LinkResend = styled.span`
  font-weight: bold;
  font-size: 16px;
  color: #1b75bb;
  letter-spacing: 0;
  line-height: 21px;
  margin: 30px 0 0 5px;
  cursor: pointer;
  text-decoration: none;
`;

const ContactUs = styled.a`
  font-size: 16px;
  color: #333;
  letter-spacing: 0;
  line-height: 21px;
  margin: 20px 0 0;
  text-align: center;
  font-weight: 600;
  text-decoration: underline;
`;

const Image = styled.img.attrs(() => ({
  src: mailImage,
  alt: 'Email Sent',
}))`
  width: 100%;
  align-self: flex-start;
`;

export default StyledEmailSentView;

export {
  Text,
  ImageWrapper,
  UserEmail,
  Title,
  LinkResend,
  ContactUs,
  Image,
};
